module.exports = __webpack_public_path__ + "static/media/IMG_4256.1bb7457a.PNG";